<template>
  <div>
    <div class="card">
      <ul class="list-data no-links no-hover">
        <li>
          <div class="row align-items-center">
            <div class="col">
              <p>Performance Objectives</p>
            </div>

            <div class="col-auto">
              <router-link v-if="!placementIsFinalised" :to="{ name: 'placements.single.end.manager.performance', params: { placementId: placement.id, graduateId: placement.graduate_id } }" class="btn btn-sm btn-outline-dark">
                Edit
              </router-link>
            </div>
          </div>
        </li>

        <li>
          <div class="row align-items-center">
            <div class="col">
              <p>Capability Assessment</p>
            </div>

            <div class="col-auto">
              <router-link v-if="!placementIsFinalised" :to="{ name: 'placements.single.end.manager.capabilities', params: { placementId: placement.id, graduateId: placement.graduate_id } }" class="btn btn-sm btn-outline-dark">
                Edit
              </router-link>
            </div>
          </div>
        </li>

        <li>
          <div class="row align-items-center">
            <div class="col">
              <p>Overall Placement Assessment</p>
            </div>

            <div class="col-auto">
              <router-link v-if="!placementIsFinalised" :to="{ name: 'placements.single.end.manager.overall', params: { placementId: placement.id, graduateId: placement.graduate_id } }" class="btn btn-sm btn-outline-dark">
                Edit
              </router-link>
            </div>
          </div>
        </li>
      </ul><!-- /.list-data -->
    </div><!-- /.card -->

    <template v-if="placementEndComponentIsPendingReview && placementStartComponentIsSignedOff && !showAlert">
      <h3 class="mt-5">Manager Sign-Off</h3>

      <div class="alert alert-info">
        <div class="row">
          <div class="col d-flex align-items-center">Please select 'Approve' to sign off the graduate's End of Placement Plan OR assist the graduate if any amendments are required.</div>
          <div class="col-auto">
            <ladda-button :click="handleApprovePlacement" class="btn btn-success btn-approve-placement-plan">Approve</ladda-button>
          </div>
        </div><!-- /.row -->
      </div><!-- /.alert -->
    </template>

    <template v-if="placementIsFinalised">
      <div class="alert alert-info">
        <div class="row">
          <div class="col d-flex align-items-center">Placement has been finalised.</div>
        </div><!-- /.row -->
      </div><!-- /.alert -->
    </template>

    <div class="alert alert-danger" v-if="showAlert">
      <strong>Warning</strong> There are errors or missing data on the following sections,
      <template v-if="!placementEndComponentPerformanceObjectivesComplete"><strong>Performance Objectives</strong>,</template>
      <template v-if="!placementEndComponentCapabilityAssessmentComplete"><strong>Capability Assessessment</strong>,</template>
      <template v-if="!placementEndComponentOverallAssessmentComplete"><strong>Overall Placement Assessment</strong>.</template>
      Please review them before finalising.
    </div><!-- /.alert -->

    <div class="alert alert-danger" v-if="!placementStartComponentIsSignedOff">
      <strong>Warning</strong> The start component must be approved before finalising.
    </div><!-- /.alert -->
  </div>
</template>

<script>
import { placementComputed, placementMethods } from 'vx/helpers'
import { first } from 'lodash'
import { alert } from 'utils'
import { helpers } from 'mixins/placements'

export default {
  mixins: [helpers],

  computed: {
    ...placementComputed,

    showAlert () {
      return !this.placementEndComponentPerformanceObjectivesComplete || !this.placementEndComponentCapabilityAssessmentComplete || !this.placementEndComponentOverallAssessmentComplete
    }
  },

  methods: {
    ...placementMethods,

    async handleApprovePlacement () {
      if (
        !await alert.confirm({
          title: 'Finalise Placement?',
          text: 'Are you sure you want to finalise this placement?'
        })
      ) {
        return
      }

      try {
        await this.approveEndComponent({ graduate: this.placement.graduate_id, placement: this.placement })

        this.setPlacementProperty({ property: 'end_component.status', value: 'signed_off' })
        this.$router.push({ name: 'graduates.placements.single', params: { placementId: this.placement.id, graduateId: this.placement.graduate_id } })
        this.$noty.success('Successfully approved')
      } catch (error) {
        this.$noty.error(first(this.errors.items).msg)
      }
    }
  }
}
</script>
